import * as React from "react";
import { forwardRef } from "react";
const SvgCircledPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", style: {
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 2
}, viewBox: "0 0 21 20", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.355 9.785h-3.531v-3.54a.323.323 0 0 0-.322-.322.323.323 0 0 0-.322.322v3.54H6.646a.325.325 0 0 0-.323.322c0 .177.146.323.323.323h3.534v3.524a.323.323 0 0 0 .645 0V10.43h3.53a.324.324 0 0 0 .322-.322.324.324 0 0 0-.322-.323Z", style: {
  fillRule: "nonzero"
} }), /* @__PURE__ */ React.createElement("path", { d: "M17.805 7.021a7.963 7.963 0 0 0-7.334-4.882c-4.361 0-7.95 3.589-7.95 7.95 0 1.066.214 2.121.63 3.102a7.963 7.963 0 0 0 7.32 4.848c4.361 0 7.95-3.589 7.95-7.95 0-1.053-.21-2.096-.616-3.068Zm-2.155 8.235a7.283 7.283 0 0 1-5.15 2.134c-3.995 0-7.282-3.288-7.282-7.282 0-3.995 3.287-7.282 7.282-7.282s7.282 3.286 7.282 7.281a7.238 7.238 0 0 1-2.133 5.15l.001-.002v.001Z", style: {
  fillRule: "nonzero"
} }));
const ForwardRef = forwardRef(SvgCircledPlus);
export { ForwardRef as ReactComponent };
